module.exports = __webpack_public_path__ + "static/media/ReportGray.4373a370.svg";